import { render, staticRenderFns } from "./PopupChangeStatus.vue?vue&type=template&id=f0e0e864&"
import script from "./PopupChangeStatus.vue?vue&type=script&lang=ts&"
export * from "./PopupChangeStatus.vue?vue&type=script&lang=ts&"
import style0 from "./PopupChangeStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports